module.exports = __webpack_public_path__ + "media/images/global/icons/kimono-62bcb1c88f8d6421a8a56fe0bc0b9130.svg";